var map = {
	"./bell.svg": "JTek",
	"./buy.svg": "+G4m",
	"./chart.svg": "Oip+",
	"./clock.svg": "70TV",
	"./cms.svg": "/RtJ",
	"./discover.svg": "Gxm9",
	"./email.svg": "wu45",
	"./facebook.svg": "WTGj",
	"./idea.svg": "jGpx",
	"./linkedin.svg": "i7Zg",
	"./linkedinsq.svg": "M5ng",
	"./location.svg": "dV2V",
	"./logo-black-landscape.svg": "RjGF",
	"./logo-white-landscape.svg": "tmrZ",
	"./menu.svg": "9H6L",
	"./microphone.svg": "izXL",
	"./navigation.svg": "ElHb",
	"./note.svg": "Z+ss",
	"./person.svg": "Zppt",
	"./persongear.svg": "bGNA",
	"./phone.svg": "mC8F",
	"./shirt.svg": "auzU",
	"./swipestation.svg": "9M3S",
	"./ticket.svg": "HADC",
	"./twitter.svg": "OPph",
	"./ui.svg": "GcNV",
	"./user.svg": "f2No"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OMOf";